import React from "react";
import {getTranslation} from "../../../helpers/get-translation";

const style={
	'width': '100px'
};
const bubbleLogo = getTranslation("image_main_bubble_logo");

function BubbleLogo() {
	return (
		<img style={style} src={bubbleLogo} alt="Bubble Logo"/>
	);
}

export default BubbleLogo;